/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoSysMaintenanceRemoveRequest model module.
 * @module model/SystemControllerDtoSysMaintenanceRemoveRequest
 * @version 1.0
 */
class SystemControllerDtoSysMaintenanceRemoveRequest {
    /**
     * Constructs a new <code>SystemControllerDtoSysMaintenanceRemoveRequest</code>.
     * @alias module:model/SystemControllerDtoSysMaintenanceRemoveRequest
     */
    constructor() { 
        
        SystemControllerDtoSysMaintenanceRemoveRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoSysMaintenanceRemoveRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoSysMaintenanceRemoveRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoSysMaintenanceRemoveRequest} The populated <code>SystemControllerDtoSysMaintenanceRemoveRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoSysMaintenanceRemoveRequest();

            if (data.hasOwnProperty('maintenanceNo')) {
                obj['maintenanceNo'] = ApiClient.convertToType(data['maintenanceNo'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoSysMaintenanceRemoveRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoSysMaintenanceRemoveRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['maintenanceNo'])) {
            throw new Error("Expected the field `maintenanceNo` to be an array in the JSON data but got " + data['maintenanceNo']);
        }

        return true;
    }


}



/**
 * @member {Array.<Number>} maintenanceNo
 */
SystemControllerDtoSysMaintenanceRemoveRequest.prototype['maintenanceNo'] = undefined;






export default SystemControllerDtoSysMaintenanceRemoveRequest;

